"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDropzone = _interopRequireDefault(require("react-dropzone"));

var _fileCard = _interopRequireDefault(require("../file-list/file-card"));

var _progress = _interopRequireDefault(require("./progress"));

var _uploader = _interopRequireDefault(require("./uploader"));

var _translate = _interopRequireDefault(require("../translate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var UploadModal = /*#__PURE__*/function (_React$Component) {
  _inherits(UploadModal, _React$Component);

  function UploadModal(props) {
    var _this;

    _classCallCheck(this, UploadModal);

    _this = _possibleConstructorReturn(this, (UploadModal.__proto__ || Object.getPrototypeOf(UploadModal)).call(this, props));
    _this.onKeyUp = _this.onKeyUp.bind(_assertThisInitialized(_this));
    _this.onDrop = _this.onDrop.bind(_assertThisInitialized(_this));
    _this.onRemoveFile = _this.onRemoveFile.bind(_assertThisInitialized(_this));
    _this.startUpload = _this.startUpload.bind(_assertThisInitialized(_this));
    _this.state = {
      filesToUpload: [],
      showProgress: false,
      uploadProgress: 0,
      showError: false
    };
    _this.messages = {
      uploadError: props.t('an error occurred during upload'),
      validationError: props.t('files are too large')
    };
    _this.errorMessage = '';
    return _this;
  }

  _createClass(UploadModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.modal = document.createElement('div');
      document.body.appendChild(this.modal);
      this.renderLayer();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _reactDom.default.unmountComponentAtNode(this.modal);

      document.body.removeChild(this.modal);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.renderLayer();

      if (this.props.isOpen) {
        document.documentElement.classList.add('upload-modal-is-open');

        if (this.props.escClose) {
          document.addEventListener('keyup', this.onKeyUp);
        }
      } else {
        document.removeEventListener('keyup', this.onKeyUp);
        document.documentElement.classList.remove('upload-modal-is-open');
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      // eslint-disable-line camelcase
      if (!nextProps.isOpen && !this.props.persistentSelection) {
        this.setState({
          filesToUpload: []
        });
      }
    }
  }, {
    key: "onKeyUp",
    value: function onKeyUp(e) {
      if (e.code === 'Escape') {
        e.preventDefault();
        this.props.closeHandler(e);
      }
    }
  }, {
    key: "onDrop",
    value: function onDrop(acceptedFiles) {
      var _this2 = this;

      if (acceptedFiles.every(function (file) {
        return _this2.validateFile(file);
      })) {
        this.setState({
          filesToUpload: this.state.filesToUpload.concat(acceptedFiles),
          showError: false
        });
      } else {
        this.errorMessage = this.messages.validationError;
        this.setState({
          showError: true
        });
      }
    }
  }, {
    key: "onRemoveFile",
    value: function onRemoveFile(id) {
      this.setState({
        filesToUpload: this.state.filesToUpload.filter(function (file) {
          return file.name !== id;
        })
      });
    }
  }, {
    key: "startUpload",
    value: function startUpload() {
      var _this3 = this;

      var upload = (0, _uploader.default)({
        name: this.props.name,
        fileList: this.state.filesToUpload,
        postUrl: this.props.postUrl
      });
      upload.on('start', function () {
        _this3.setState({
          showProgress: true,
          uploadProgress: 0
        });
      });
      upload.on('progress', function (progress) {
        _this3.setState({
          uploadProgress: progress.loaded / progress.total * 100
        });
      });
      upload.on('success', function (response) {
        // Force a small delay for UX purposes.
        setTimeout(function () {
          _this3.setState({
            showProgress: false,
            uploadProgress: 0,
            filesToUpload: []
          });

          _this3.props.onUploadSuccess(JSON.parse(response.response));
        }, 300);
      });
      upload.on('error', function (message) {
        _this3.errorMessage = typeof message === 'string' ? message : _this3.messages.uploadError;

        _this3.setState({
          showError: true,
          showProgress: false,
          uploadProgress: 0,
          filesToUpload: []
        });

        _this3.props.onUploadError(_this3.errorMessage);
      });
      upload.start();
    }
  }, {
    key: "validateFile",
    value: function validateFile(file) {
      // Check for file size
      return file.size <= this.props.maxFilesize;
    }
  }, {
    key: "renderLayer",
    value: function renderLayer() {
      var _this4 = this;

      var t = this.props.t;
      /* eslint-disable max-len */

      _reactDom.default.render( /*#__PURE__*/_react.default.createElement("div", {
        id: this.props.id,
        className: 'upload-modal ' + (this.props.isOpen ? 'is-open' : '')
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "upload-modal__background",
        onClick: this.props.backgroundClickClose ? this.props.closeHandler : null
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: 'upload-modal__content' + (this.state.showProgress ? ' is-uploading' : '')
      }, /*#__PURE__*/_react.default.createElement(_progress.default, {
        show: this.state.showProgress,
        progress: this.state.uploadProgress
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "upload-modal__scrollable"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x grid-padding-x"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell"
      }, /*#__PURE__*/_react.default.createElement("h2", null, t('upload files')), /*#__PURE__*/_react.default.createElement(_reactDropzone.default, {
        onDrop: this.onDrop,
        className: "dropzone",
        activeClassName: "dropzone--active"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "dropzone__inner"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "dropzone__caption"
      }, t('Click or drag & drop')), /*#__PURE__*/_react.default.createElement("span", {
        className: "dropzone__caption-icon"
      }, /*#__PURE__*/_react.default.createElement("svg", {
        viewBox: "0 0 100 100"
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M87.5,18v-2c0-2.961-0.359-3.5-3.5-3.5H16c-2.961,0-4.5,0.48-4.5,3.5v2c0,3.102,1.539,4.5,4.5,4.5h68   C87.02,22.5,87.5,21.039,87.5,18z M58,88.5c4.939,0,5.5-1.439,5.5-6.5V60.5H84l-34-34l-34,34h19.5V82c0,5.061,1.5,6.5,6.5,6.5H58z"
      }))))), this.state.showError ? /*#__PURE__*/_react.default.createElement("p", {
        className: 'error-message'
      }, this.errorMessage) : null)), this.state.filesToUpload.length ? /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x grid-padding-x"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell"
      }, /*#__PURE__*/_react.default.createElement("h2", null, t('Preview')))) : null, /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x grid-padding-x small-up-2 medium-up-3 large-up-4 xlarge-up-5"
      }, this.state.filesToUpload.map(function (file, index) {
        return /*#__PURE__*/_react.default.createElement("div", {
          key: index,
          className: "cell"
        }, /*#__PURE__*/_react.default.createElement(_fileCard.default, {
          isImage: file.type.startsWith('image/'),
          imgId: file.name,
          smallUrl: file.preview,
          mediumUrl: file.preview,
          largeUrl: file.preview,
          filename: file.name,
          onDelete: _this4.onRemoveFile
        }));
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x grid-padding-x"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell"
      }, /*#__PURE__*/_react.default.createElement("ul", {
        className: "cta-buttons"
      }, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn",
        onClick: this.startUpload,
        disabled: this.state.filesToUpload.length === 0
      }, t('start upload'))), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn--secondary",
        onClick: this.props.closeHandler
      }, t('cancel'))))))))), this.modal);
      /* eslint-enable max-len */

    }
  }, {
    key: "render",
    value: function render() {
      // Render a placeholder
      return /*#__PURE__*/_react.default.createElement("div", null);
    }
  }]);

  return UploadModal;
}(_react.default.Component);

UploadModal.defaultProps = {
  name: 'file-select-1',
  maxFilesize: 3 * 1024 * 1024,
  // 3 MB. just an arbitrary default max. size.
  persistentSelection: false,
  closeHandler: function closeHandler() {},
  escClose: true,
  backgroundClickClose: false,
  onUploadSuccess: function onUploadSuccess() {},
  onUploadError: function onUploadError() {}
};
UploadModal.propTypes = {
  maxFilesize: _propTypes.default.number,
  name: _propTypes.default.string,
  postUrl: _propTypes.default.string.isRequired,
  persistentSelection: _propTypes.default.bool,
  closeHandler: _propTypes.default.func,
  escClose: _propTypes.default.bool,
  backgroundClickClose: _propTypes.default.bool,
  onUploadSuccess: _propTypes.default.func,
  onUploadError: _propTypes.default.func,
  id: _propTypes.default.number,
  isOpen: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  t: _propTypes.default.func
};

var _default = (0, _translate.default)(UploadModal);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/upload-modal/index.js
// module id = 729
// module chunks = 0